import AvatarStrapi from '@/components/atoms/avatar/AvatarStrapi';
import BadgeSB from '@/components/atoms/badge/BadgeSB';
import DividerSB from '@/components/atoms/divider/DividerSB';
import HeadingSB from '@/components/atoms/heading/HeadingSB';
import ImageSB from '@/components/atoms/image/ImageSB';
import FooterBannerStrapi from '@/components/atoms/layout/footer/FooterBannerStrapi';
import LinkButtonSB from '@/components/atoms/linkButton/LinkSB';
import RichTextFieldSB from '@/components/atoms/richTextField/RichTextFieldSB';
import TextSB from '@/components/atoms/text/TextSB';
import VideoSB from '@/components/atoms/video/VideoSB';
import { G2BadgeSB } from '@/components/integrations/g2/G2BadgeSB';
import { ProxywayBadgeSB } from '@/components/integrations/proxyway/ProxywayBadgeSB';
import { TrustpilotBadgeSB } from '@/components/integrations/trustpilot/TrustpilotBadgeSB';
import AccordionListSB from '@/components/molecules/accordion/AccordionListSB';
import { BannerStrapi } from '@/components/molecules/banner/BannerStrapi';
import { SideBannerStrapi } from '@/components/molecules/banner/SideBannerStrapi';
import { BreadcrumbsStrapi } from '@/components/molecules/breadcrumbs/BreadcrumbsStrapi';
import { ImageBlockStrapi } from '@/components/molecules/imageBlock/ImageBlockStrapi';
import { ImageLinkStrapi } from '@/components/molecules/imageLink/ImageLinkStrapi';
import { QuoteComponentStrapi } from '@/components/molecules/quote/QuoteComponentStrapi';
import { AuthorStrapi } from '@/components/organisms/author/AuthorStrapi';
import { TableStrapi } from '@/components/organisms/table/TableStrapi';
import { TextGridStrapi } from '@/components/organisms/textGrid/TextGridStrapi';

import FAQStrapi from '@/features/accordions/FAQStrapi';
import { HeroWithBackgroundStrapi } from '@/features/backgroundImageHero/BackgroundImageHeroStrapi';
import CardsWithHeaderStrapi from '@/features/cards/CardsWithHeader/CardsWithHeaderStrapi';
import { PricingCardsStrapi } from '@/features/cards/PricingCards/PricingCardsStrapi';
import ProductCardsStrapi from '@/features/cards/ProductCards/ProductCardsStrapi';
import { RecommendationCardsStrapi } from '@/features/cards/RecommendationCards/RecommendationCardsStrapi';
import SimpleCardsStrapi from '@/features/cards/SimpleCards/SimpleCardsStrapi';
import { CareersHeroStrapi } from '@/features/careersHero/CareersHeroStrapi';
import { CarouselBlockStrapi } from '@/features/carouselBlock/CarouselBlockStrapi';
import { CodeBlockStrapi } from '@/features/codeBlock/CodeBlockStrapi';
import { HeroStrapi } from '@/features/hero/HeroStrapi';
import { HeroWithSearchStrapi } from '@/features/heroWithSearch/HeroWithSearchStrapi';
import { HomepageHeroStrapi } from '@/features/homepageHero/HomepageHeroStrapi';
import { ImageWithCardsCarouselStrapi } from '@/features/imageWithCardsCarousel/imageWithCardsCarouselStrapi';
import { JobApplicationFormStrapi } from '@/features/jobApplicationForm/JobApplicationFormStrapi';
import { LogoCarouselStrapi } from '@/features/logoCarousel/LogoCarouselStrapi';
import { PopupBannerStrapi } from '@/features/PopupBanner/PopupBannerStrapi';
import { PricingTableStrapi } from '@/features/pricingTable/PricingTableStrapi';
import { ScraperStrapi } from '@/features/scraper/ScraperStrapi';
import { BlogOverviewStrapi } from '@/features/shared/BlogOverview/BlogOverviewStrapi';
import { CTABlockStrapi } from '@/features/shared/CTABlockStrapi';
import { TextBlockStrapi } from '@/features/shared/TextBlockStrapi';
import { VideoBlockStrapi } from '@/features/shared/VideoBlockStrapi';
import { SocialProofStrapi } from '@/features/socialProof/SocialProofStrapi';
import ImageAccordionsStrapi from '@/features/textMedia/imageAccordions/ImageAccordionsStrapi';
import { ImageTextStrapi } from '@/features/textMedia/imageText/ImageTextStrapi';
import { TopBannerStrapi } from '@/features/topBanner/TopBannerStrapi';
import { WhatIsMyIpHeroStrapi } from '@/features/whatIsMyIpHero/WhatIsMyIpHeroStrapi';

import { ArticlesFeedStrapi } from '../organisms/articles-feed/ArticlesFeedStrapi';
import GatedContentBlockStrapi from '../organisms/gated-content/GatedContentBlockStrapi';
import { OpenPositionsListStrapi } from '../organisms/openPositionsList/OpenPositionsListStrapi';
import { RelatedArticlesStrapi } from '../organisms/relatedArticles/RelatedArticlesStrapi';
import ScrapingTemplateLibrary from '../organisms/ScrapingTemplateLibrary';
import ScrapingTemplatesPreviewStrapi from '../organisms/ScrapingTemplatesPreview/ScrapingTemplatesPreviewStrapi';
import SocialWidget from '../organisms/socialWidget/SocialWidgetStrapi';

export const ComponentsMap: { [key: string]: React.ElementType } = {
  // atoms
  'atoms.badge': BadgeSB,
  'atoms.heading': HeadingSB,
  'atoms.rich-text-field': RichTextFieldSB,
  'atoms.link': LinkButtonSB,
  'atoms.image': ImageSB,
  'atoms.divider': DividerSB,
  'atoms.text': TextSB,
  'atoms.video': VideoSB,
  'atoms.avatar': AvatarStrapi,
  // spacing: SpacingSB,
  // molecules
  'molecules.breadcrumbs': BreadcrumbsStrapi,
  'molecules.accordion-list': AccordionListSB,
  'molecules.image-link': ImageLinkStrapi,
  'molecules.quote-component': QuoteComponentStrapi,
  'molecules.image-block': ImageBlockStrapi,
  'molecules.banner': BannerStrapi,
  // organisms
  'organisms.code-block': CodeBlockStrapi,
  'organisms.table': TableStrapi,
  'organisms.text-grid': TextGridStrapi,
  'organisms.open-positions-list': OpenPositionsListStrapi,
  'organisms.social-widget': SocialWidget,
  'organisms.scraping-template-library': ScrapingTemplateLibrary,
  'organisms.scraping-template-preview': ScrapingTemplatesPreviewStrapi,
  // integrations
  'integration.g2-badge': G2BadgeSB,
  'integration.proxyway-badge': ProxywayBadgeSB,
  'integration.trustpilot-badge': TrustpilotBadgeSB,
  // faq
  'accordions.faq': FAQStrapi,
  // layout
  'layout.footer-banner': FooterBannerStrapi,
  // cards
  'cards.cards-with-header': CardsWithHeaderStrapi,
  'cards.pricing-cards': PricingCardsStrapi,
  'cards.simple-cards': SimpleCardsStrapi,
  'cards.recommendation-cards': RecommendationCardsStrapi,
  'cards.social-proof': SocialProofStrapi,
  'cards.product-cards': ProductCardsStrapi,
  'cards.pricing-table': PricingTableStrapi,
  // text-media
  'text-media.image-accordions': ImageAccordionsStrapi,
  'shared.image-text': ImageTextStrapi,
  'hero.hero': HeroStrapi,
  'hero.background-image-hero': HeroWithBackgroundStrapi,
  'hero.homepage-hero': HomepageHeroStrapi,
  'hero.what-is-my-ip-hero': WhatIsMyIpHeroStrapi,
  'hero.hero-with-search': HeroWithSearchStrapi,
  'hero.careers-hero': CareersHeroStrapi,
  // blog
  'blog.blog-side-banner': SideBannerStrapi,
  'blog.author': AuthorStrapi,
  'blog.related-articles': RelatedArticlesStrapi,
  'blog.articles-feed': ArticlesFeedStrapi,
  // shared
  'shared.text-block': TextBlockStrapi,
  'shared.video-block': VideoBlockStrapi,
  'shared.cta-block': CTABlockStrapi,
  'shared.blog-overview': BlogOverviewStrapi,
  'shared.scraper': ScraperStrapi,
  'shared.popup-banner': PopupBannerStrapi,
  'shared.job-application-form': JobApplicationFormStrapi,
  'shared.gated-content': GatedContentBlockStrapi,
  // carousels
  'carousels.carousel-block': CarouselBlockStrapi,
  'carousels.top-banner': TopBannerStrapi,
  'carousels.hero-carousel': ImageWithCardsCarouselStrapi,
  'carousels.images-carousel': LogoCarouselStrapi,
};
